// extracted by mini-css-extract-plugin
export default {"wrap":"iH-z","articleImagesWrap":"jH-z","articleImage":"kH-z","singleImage":"lH-z"};